import styled from "styled-components"
import { readableColor } from "polished"

const getBackgroundColorFromVariant = (variant, theme) => {
  switch (variant) {
    case "danger":
      return theme.colors.danger
    case "warning":
      return theme.colors.warning
    case "success":
      return theme.colors.success
    default:
      return "hsla(0, 0%, 0%, 0.2)"
  }
}

const getTextColorFromVariant = (variant, theme) => {
  const backgroundColor = getBackgroundColorFromVariant(variant, theme)
  return readableColor(backgroundColor, theme.colors.buttons.darkColor, theme.colors.buttons.lightColor)
}

export const Container = styled.div`
  color: ${({ variant, theme }) => getTextColorFromVariant(variant, theme)};
  background-color: ${({ variant, theme }) => getBackgroundColorFromVariant(variant, theme)};
  padding: 0.5rem 5px;
  font-weight: bold;
  text-align: center;
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
  box-sizing: border-box;
  z-index: 2;
`
